// import { useState } from "react";
import GoogleButton from '../components/login/GoogleButton';
// import { signInWithEmailPassword } from "../client/firebase/auth";
import TwLogo from '../assets/images/thoughtworks_flamingo_mist.png';
import WelcomeImage from "../assets/images/tw_photos_remote_working_0009_bw.jpg";
// import { useNavigate } from "react-router-dom";

const Home = () => {
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  // const navigate = useNavigate();

  // const handleSignIn = async (e) => {
  //   e.preventDefault();
  //   try {
  //     await signInWithEmailPassword(email, password);
  //     navigate("/dashboard");
  //   } catch (error) {
  //     console.error(error);
  //     alert("Invalid email or password");
  //   }
  // };

  return (
    <div className='justify-between py-6 px-8  font-inter items-center'>
      <img src={TwLogo} className='h-8 pr-4' alt='Thoughtworks logo' />

      <div className='container mx-auto flex flex-col lg:flex-row h-[90svh] items-center justify-center gap-4 lg:justify-between'>
        <div className='max-w-[750px] mr-10 p-4 lg:p-11'>
          <h1 b className='text-5xl sm:text-5xl font-bitter  mb-2'>
            Say hello to 👋
            <div b className='text-5xl sm:text-5xl py-2 font-bitter font-bold text-sapphire-blue'>
              Code Studio
            </div>
          </h1>
          <h2 className='mb-10 text-xl '>
            AI-powered assistant for software development
          </h2>
          <GoogleButton />
        </div>
        {/* <form
          onSubmit={handleSignIn}
          className='space-y-4 flex flex-col items-start w-80'
        >
          <input
            type='email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder='Email'
            required
            className='w-full px-3 py-2 shadow rounded-md bg-black-transparent'
          />
          <input
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder='Password'
            required
            className='w-full px-3 py-2 shadow rounded-md bg-black-transparent'
          />
          <button
            type='submit'
            className='px-8 py-2 rounded-md bg-flamingo-pink text-white'
          >
            Sign In
          </button>
        </form> */}

        <div className="absolute bottom-6 right-1/2 translate-x-1/2 lg:right-5 lg:translate-x-0 -z-10 bg-white opacity-20 w-[100%] lg:opacity-100 lg:bg-transparent lg:w-[60%] h-[95%]">

        <img
          className='object-cover w-full h-full'
          src={WelcomeImage}
          alt='welcome'
        />
      </div>
    </div>
    </div>
  );
};

export default Home;
